module.exports = __webpack_public_path__ + "img/20200502_203717.098ba694.jpg";